import { Button, Collapse, CollapseProps, Empty } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { ChevronDownIcon, ChevronUpIcon } from "../../../assets/svg";
import { SectionLoader } from "../../atoms/SectionLoader/SectionLoader";
import { BankDetailItem } from "./BankDetailItem";
import { RequestBankDetailButton } from "./RequestBankDetailButton";
import { useGetBankDetails } from "./api";

const HEIGHT = "18rem";

export const TenantBankDetails = () => {
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const tenantId = bookingDetails?.tenantId;

  const { bankDetails, isLoadingBankDetails } = useGetBankDetails({ tenantId });

  const hasBankDetails: boolean = bankDetails && Object.keys(bankDetails).length > 0;

  const renderExpandIcon: CollapseProps["expandIcon"] = ({ isActive }) => (
    <Button
      type="text"
      style={{ borderRadius: 6, width: "1.5rem", display: "grid", justifyContent: "center", alignItems: "center" }}
    >
      {isActive ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Button>
  );

  return (
    <Collapse
      className="ds-collapse"
      defaultActiveKey="tenant-bank-details"
      expandIconPosition="end"
      collapsible={hasBankDetails ? "icon" : "disabled"}
      expandIcon={hasBankDetails ? renderExpandIcon : () => null}
      style={{ backgroundColor: "white", maxWidth: "28.5rem" }}
      destroyInactivePanel
    >
      <Collapse.Panel
        key="tenant-bank-details"
        header={
          <span style={{ fontWeight: 700, color: "var(--blue-600)", fontSize: "1.125rem" }}>Tenant Bank Details</span>
        }
        extra={
          <RequestBankDetailButton
            tenantId={tenantId}
            hasBankDetails={hasBankDetails}
            isLoadingBankDetails={isLoadingBankDetails}
          />
        }
      >
        <div style={{ minHeight: HEIGHT }}>
          <SectionLoader isLoading={isLoadingBankDetails} containerStyle={{ height: HEIGHT }}>
            {bankDetails ? (
              <>
                <BankDetailItem label="Bank Name" value={bankDetails?.bankName} />
                <BankDetailItem label="Account Name" value={bankDetails?.accountHolderName} />
                <BankDetailItem label="Account no." value={bankDetails?.accountNo} />
                <BankDetailItem
                  label="IBAN"
                  value={bankDetails?.iban}
                  labelStyle={{ display: "flex", alignItems: "center" }}
                  withDivider={false}
                />
              </>
            ) : (
              <Empty style={{ height: HEIGHT, display: "grid", placeContent: "center" }} />
            )}
          </SectionLoader>
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};
